module.exports = __webpack_public_path__ + "static/media/doc.2ce86ba2.svg";